import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    reduxForm,
    Field,
    getFormValues
} from 'redux-form';

import ContentCard from '../common/template/contentCard';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import Select from '../common/form/select';

import {
    setModoTela,
    initForm
} from './centroCustoActions';

let CentroCustoForm = props => {

    const formulario =
        props.formularioValues || {};

    const readOnly = props.excluir
        ? 'readOnly'
        : '';

    const listaCentroCustoPai = (
        props.listaCentroCusto || []
    ).filter(item =>
        Number(item.id) !== Number(formulario.id)
    );

    return (
        <ContentCard>
            <Form event={props.handleSubmit}>
                <ContentCardBody>

                    <Row>
                        <Field
                            name='codigo'
                            component={LabelAndInput}
                            label='Código'
                            placeholder='Informe'
                            cols='12 3 3 3'
                            readOnly={readOnly}
                        />

                        <Field
                            name='nome'
                            component={LabelAndInput}
                            label='Nome *'
                            placeholder='Informe'
                            cols='12 9 9 9'
                            readOnly={readOnly}
                        />
                    </Row>

                    <Row>
                        <Field
                            name='id_centro_custo_pai'
                            options={listaCentroCustoPai}
                            component={Select}
                            label='Centro de Custo Pai'
                            placeholder='Selecione'
                            cols='12 12 6 6'
                            readOnly={readOnly}
                        />
                    </Row>

                    <Row>
                        <Field
                            name='observacao'
                            component={LabelAndInput}
                            label='Observação'
                            placeholder='Informe'
                            cols='12 12 12 12'
                            readOnly={readOnly}
                        />
                    </Row>

                </ContentCardBody>

                <ContentCardFooter>
                    <Row alignCenter>
                        <Grid cols='6 6 4 3'>
                            <Button
                                text='Voltar'
                                type='light'
                                icon='fa fa-chevron-left'
                                event={() =>
                                    props.setModoTela('lista')
                                }
                            />
                        </Grid>

                        <Grid cols='6 6 4 3'>
                            {props.excluir &&
                                <Button
                                    text='Excluir'
                                    submit
                                    type='danger'
                                    icon='fa fa-trash'
                                />}

                            {!props.excluir &&
                                <Button
                                    text='Salvar'
                                    submit
                                    type='success'
                                    icon='fa fa-check'
                                />}
                        </Grid>
                    </Row>
                </ContentCardFooter>
            </Form>
        </ContentCard>
    );
};

CentroCustoForm = reduxForm({
    form: 'centroCustoForm',
    destroyOnUnmount: false
})(CentroCustoForm);

const mapStateToProps = state => ({
    sessao: state.auth.usuario,

    formularioValues:
        getFormValues('centroCustoForm')(state),

    registro:
        state.centroCusto.registro,

    listaCentroCusto:
        state.centroCusto.listaSelect
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        setModoTela,
        initForm
    }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CentroCustoForm);